import { firestoreAction } from 'vuexfire'
import * as firebase from 'firebase'
import db from '@/db'

const rolesRef = db.collection('roles')
const tasksRef = db.collection('tasks')
const orgRef = db.collection('organization')
const redFlagsRef = db.collection('redFlags')
const updated = firebase.default.firestore.FieldValue.serverTimestamp()

const initialState = {
  roles: [],
  rolesLoading: true
}

const state = Object.assign({}, initialState)

const mutations = {
  'SET_PHASES_LOADING' (state, loading) {
    state.rolesLoading = loading
  },
  'RESET_STATE' (state) {
    for (let prop in state) {
      state[prop] = initialState[prop]
    }
  }
}

const actions = {
  resetRoleState: firestoreAction(({ unbindFirestoreRef }) => {
    unbindFirestoreRef('roles')
  }),
  setRolesRef: firestoreAction(({ bindFirestoreRef, commit, dispatch }, ref) => {
    bindFirestoreRef('roles', ref).then(response => {
      commit('SET_PHASES_LOADING', false)
      dispatch('toggleLoading', false)
    }).catch(error => {
      console.log(error)
    })
  }),
  addRole: ({ dispatch, rootGetters }, payload) => {
    return new Promise((resolve, reject) => {
      let role = { ...payload }
      rolesRef.add(role).then(entry => {
        let roleInfo = {
          updated: updated
        }
        const roleKey = 'roles.' + entry.id
        roleInfo[roleKey] = true
        orgRef.doc(payload.organization).update(roleInfo).then(response => {
          dispatch('saveState', true)
        }).catch(error => {
          console.log(error)
        })
        rootGetters.redFlags.forEach(flag => {
          const roleKey = 'roles.' + entry.id
          const newRole = {}
          newRole[roleKey] = { impact: 0 }
          redFlagsRef.doc(flag.id).update(newRole)
        })
        resolve(entry.id)
      }).catch(error => {
        console.log(error)
        reject(error)
      })
    })
  },
  editRole: ({ dispatch }, payload) => {
    let role = { ...payload }
    role.updated = updated
    rolesRef.doc(role.id).update(role).then(item => {
      dispatch('saveState', true)
    }).catch(error => {
      console.log(error)
    })
  },
  deleteRole: ({ rootGetters, dispatch }, payload) => {
    const redFlags = rootGetters.redFlags
    const tasks = rootGetters.roleTasks(payload.id)
    const batch = db.batch()
    const role = rolesRef.doc(payload.id)
    batch.delete(role)

    // Remove role from all red flags
    redFlags.forEach(flag => {
      const redflag = redFlagsRef.doc(flag.id)
      const flagField = 'roles.' + payload.id
      const flagInfo = {}
      flagInfo.updated = updated
      flagInfo[flagField] = firebase.default.firestore.FieldValue.delete()
      batch.update(redflag, flagInfo)
    })

    // Remove role from all tasks
    tasks.forEach(task => {
      const taskDoc = tasksRef.doc(task.id)
      const taskInfo = {
        updated: updated,
        role: false
      }
      batch.update(taskDoc, taskInfo)
    })

    // Rmove from org
    const org = orgRef.doc(payload.organization)
    const orgField = 'roles.' + payload.id
    const orgInfo = {}
    orgInfo.updated = updated
    orgInfo[orgField] = firebase.default.firestore.FieldValue.delete()
    batch.update(org, orgInfo)
    batch.commit().then(response => {
      dispatch('saveState', true)
    })
  },
  duplicateRoles: ({ state, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      const oldRoles = { ...state.roles }
      const roleMatrix = {}
      const batch = db.batch()
      let roleCount = 0
      Object.keys(oldRoles).forEach(role => {
        const newRole = { ...oldRoles[role] }
        const oldRole = oldRoles[role].id
        delete newRole.id
        newRole.owner = payload.user
        newRole.created = updated
        newRole.updated = updated
        newRole.organization = payload.org
        rolesRef.add(newRole).then(reference => {
          roleMatrix[oldRole] = reference.id
          const org = orgRef.doc(payload.org)
          const orgKey = 'roles.' + reference.id
          const orgInfo = {}
          orgInfo[orgKey] = true
          batch.update(org, orgInfo)
          roleCount++
          if (roleCount === state.roles.length) {
            commitBatch()
          }
        })
      })
      function commitBatch () {
        batch.commit().then(response => {
          resolve(roleMatrix)
        }, error => {
          reject(error)
        })
      }
    })
  }
}

const getters = {
  rolesLoading: state => {
    return state.rolesLoading
  },
  roles: (state) => {
    return state.roles
  },
  role: state => (key) => {
    return state.roles.find(roles => roles.id === key)
  },
  roleList: state => {
    return state.roles.map(roles => {
      return {
        label: roles.name,
        value: roles.id
      }
    })
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
